import * as React from 'react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import { wrapWithLocationCard } from 'owa-location-card-v2';
import OwaTxpStyle from '../store/viewSchema/OwaTxpStyle';
import { isBrowserFirefox } from 'owa-user-agent/lib/userAgent';

let styles = require('./Txp.scss');
let classNames = require('classnames');
let locationIdPlaceholder = 'LocationIdPlaceholder';

export interface TxpLocationProps {
    txpLocation: EnhancedLocation;
    txpLocationIcon: string;
    locationToDisplay: string;
    txpStyle?: OwaTxpStyle;
    telephone?: string;
}

const TxpLocation = (props: TxpLocationProps) => {
    let { txpLocation, txpLocationIcon, locationToDisplay, txpStyle, telephone } = props;
    let locationId: string = txpLocation.Id || locationIdPlaceholder;
    let txpLocationElement = (
        <span className={isBrowserFirefox() ? styles.peekDataRowValueIEFF : null}>
            {locationToDisplay}
        </span>
    );

    return (
        <div className={classNames(styles.peekDataRow, txpStyle && txpStyle.locationRowStyle)}>
            <Icon iconName={txpLocationIcon} className={styles.peekDataRowIcon} />
            <div className={styles.peekDataRowValue}>
                {wrapWithLocationCard(
                    txpLocation.DisplayName,
                    txpLocation.PostalAddress,
                    locationId,
                    txpLocationElement,
                    txpStyle && txpStyle.txpColor,
                    null /* onLocationCardUnmounted */,
                    telephone
                )}
            </div>
        </div>
    );
};

export default TxpLocation;
